import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { filterReducer } from './state/filter.reducer';
import { RegionEffects } from './services/region-effects.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('filter', filterReducer),
    EffectsModule.forFeature([RegionEffects]),
  ],
})
export class ObjectSearchFilterModule {}
